export const getFullName = (firstName, lastName) => {
  if (!firstName && !lastName) {
    return "";
  }

  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
  return fullName || "";
};
